import type { NormalizedKeyword } from "./Search.types";

export const EMPTY_KEYWORD_REGEXP: NormalizedKeyword = {
  keyword: "",
  regExp: new RegExp(" "),
  wholeWords: false,
  matchCase: false
};
